import createEnhancedAsynThunk from '../../utils/createEnhancedAsynThunk';
import sliceHandler from '../../utils/sliceHandler';

const sliceArgs = {
  SLICE_NAME: 'pickup-times',
  ENDPOINT: 'venues',
  RESOURCE: 'pickup-times',
};

const sliceName = sliceArgs.SLICE_NAME;

const fetchPickupTimes = createEnhancedAsynThunk({
  name: sliceArgs.SLICE_NAME,
  endpoint: sliceArgs.ENDPOINT,
  method: 'GET',
  resource: sliceArgs.RESOURCE,
});

const extraReducers = [fetchPickupTimes];

const slice = sliceHandler({ sliceName, extraReducers });
const { reducer } = slice;

export { fetchPickupTimes };
export default reducer;
